// NEW STYPEPARAMS METHOD
var OVERLAY_BEHAVIOUR_ON_HOVER = {
    APPEARS: 'APPEARS',
    DISAPPEARS: 'DISAPPEARS',
    ALWAYS_SHOW: 'ALWAYS_SHOW',
    NEVER_SHOW: 'NEVER_SHOW',
};
export default OVERLAY_BEHAVIOUR_ON_HOVER;
//# sourceMappingURL=behaviourParams_item_overlay_hoveringBehaviour.js.map